import { ActiveSession, ActiveWorkflowContext, DockEmployee } from "app/data/dock-scan/models";

export interface DockEmployeeRow extends DockEmployee {
  lastLoginAt?: string;
  isOnDock: boolean;
  equipmentId?: string;
  sessionDurationMs?: number;
  assignmentStartedAt?: string;
  scansTotal?: number;
  scansSuccess?: number;
  scansFailure?: number;
  lastScanAt?: string;
  activeWorkflow?: ActiveWorkflowContext;
}

export function enrichDockEmployees(
  employees: DockEmployee[],
  lastLogins: { employeeId: string; lastLoginAt: string }[],
  activeSessions: ActiveSession[]
): DockEmployeeRow[] {
  const loginMap = new Map(lastLogins.map((l) => [l.employeeId, l.lastLoginAt]));
  const sessionMap = new Map(activeSessions.map((s) => [s.employeeId, s]));

  return employees.map((emp) => {
    const session = sessionMap.get(emp.employeeId);
    return {
      ...emp,
      lastLoginAt: loginMap.get(emp.employeeId),
      isOnDock: !!session,
      equipmentId: session?.equipmentId,
      sessionDurationMs: session?.sessionDurationMs,
      assignmentStartedAt: session?.assignmentStartedAt,
      scansTotal: session?.scans.total,
      scansSuccess: session?.scans.success,
      scansFailure: session?.scans.failure,
      lastScanAt: session?.scans.lastScanAt,
      activeWorkflow: session?.activeWorkflow,
    };
  });
}
